var analytics = new Analytics();
var analyticsObjects = new Object();


analyticsObjects.actions = {open: 'open', enter: 'enter', gotoAction: 'goto', change: 'change', add: 'add', remove: 'remove', slide: 'slide'};
analyticsObjects.labelElements = {logoToHome: 'home', currency: 'currency', headerMenuMobile: 'header-menu-mobile', capitals: 'capitals', recoverPassword: 'recover-password', breadcrumb: 'breadcrumb', 
									orderBy: 'order-by', mapButton: 'map', listButton: 'list', rentButton: 'listing-rent', saleButton: 'listing-sale', promotionButton: 'listing-promotion', filter: 'filter', 
									pagination: 'pagination', favourite: 'favourite', mapPolygon: 'map-polygon', mapInfo: 'map-info', detail: 'detail', agencyDetail: 'agency-detail', mapDetail: 'map-detail',
									similar:'similar', viewListing: 'view-listing', viewComplete: 'view-complete', slide: 'slide'
								};

function Analytics(){
	
	// Vuelta Atras RTB
	this.contactRTB = false;
	//Vuelta Atras RTB
	
	this.getEventMortgage = function (category, label, open,link) {
        ga('send', 'event', category, 'clic', label);
        if (open)
            launching(link);
        else
            lauchingRefresh(link);
    }
	
	this.submitSendContactOpen = function(where){
		var label = "open";
		if (where && where.trim()!='') {
			label += "-" + where;
		}
		ga('send', 'event', 'microConversion', 'SendContact', label);
		ga('global.send', 'event', 'microConversion', 'SendContact', label);
	}
	this.submitSeePhoneOpen = function(where){
		var label = "open";
		if (where && where.trim()!='') {
			label += "-" + where;
		}
		ga('send', 'event', 'microConversion', 'SeePhone', label);
		ga('global.send', 'event', 'microConversion', 'SeePhone', label);
	}
	
	this.submitCreateAlert = function(action, label){
		var l = "";
		if (label && label.trim()!=''){
			l = label;
		}
		ga('send', 'event', 'alerts', action , l);
		ga('global.send', 'event', 'alerts', action, l);
	}
	
	this.submitFavourite = function(where){
		ga('send', 'event', 'microConversion', 'favourite' , where);
		ga('global.send', 'event', 'microConversion', 'favourite' , where);
	}
	
	this.submitSendContact = function(where){
		var label = "send";
		if (where && where.trim()!='') {
			label += "-" + where;
		}
		ga('send', 'event', 'Conversion', 'ContactOk', label);
		ga('global.send', 'event', 'Conversion', 'ContactOk', label);
		if (typeof fbq != "undefined") {
			fbq('track', 'Lead');
			fbq('track', 'Purchase', {
				content_ids: "['" + adId + "']",
				content_type: 'product',
				value: 0.0,
				currency: 'USD'
			});
			
		}
	}
	
	// Vuelta Atras RTB
	this.submitSendContactRTB = function(idContact, rtbKey, adId){
		try {
			var x = document.createElement('script'); x.async = true;
			x.src = "https://us.creativecdn.com/tags?type=script&id=" + rtbKey + "_orderstatus2_1_" + idContact + "_" + adId + "&cd=default";
			document.getElementsByTagName('head')[0].appendChild(x);
		}
		catch(e){}
	};
	// Vuelta Atras RTB
	
	this.submitSeePhone = function(where){
		var label = "see";
		if (where && where.trim()!='') {
			label += "-" + where;
		}
		ga('send', 'event', 'Conversion', 'Phone', label);
		ga('global.send', 'event', 'Conversion', 'Phone', label);
//		if (typeof fbq != "undefined")
//			fbq('track', 'Purchase', {value: '0.00', currency: 'USD'});
	}

		
	this.submitSearch = function(where, search){
		ga('send', 'event', 'Search', where, search);
		ga('global.send', 'event', 'Search', where, search);
	}
		
	this.submitPublishAd = function(where){
//		ga('send', 'event', 'PublishAd', 'general', where);
//		ga('global.send', 'event', 'PublishAd', 'general', where);
		this.submitRegister(where);
	}
	
	this.submitRegister = function (where) {
		ga('send', 'event', 'Register', 'access', where);
		ga('global.send', 'event', 'Register', 'access', where);
	}
	
	this.submitSignUpParticular = function(){
//		ga('send', 'event', 'PublishAd', 'private', 'register');
//		ga('global.send', 'event', 'PublishAd', 'private', 'register');
		ga('send', 'event', 'Register', 'done', 'private');
		ga('global.send', 'event', 'Register', 'done', 'private');
	}
	
	this.submitSignUpProfessional = function(){
//		ga('send', 'event', 'PublishAd', 'professional', 'register');
//		ga('global.send', 'event', 'PublishAd', 'professional', 'register');
		ga('send', 'event', 'Register', 'done', 'professional');
		ga('global.send', 'event', 'Register', 'done', 'professional');
	}
	
	this.submitSeeAgencyAds = function(agency){
		ga('send', 'event', 'InterestAgency', agency, '');
		ga('global.send', 'event', 'InterestAgency', agency, '');
	}
		
	this.submitShareSocial = function(network){
		ga('send', 'event', 'Social', network, 'share');
		ga('global.send', 'event', 'Social', network, 'share');
	}
		
	this.submitOpenCalculatorClick = function(){
		ga('send', 'event', 'Open-Calculator', 'detail', '');
		ga('global.send', 'event', 'Open-Calculator', 'detail', '');
	}
	
	this.submitCalculatorClick = function(){
		ga('send', 'event', 'Calculator', 'detail', '');
		ga('global.send', 'event', 'Calculator', 'detail', '');
	}
	
	this.submitHomeSliderClick = function (label){
		ga('send', 'event', 'Fondo-Home', 'clic', label);
		ga('global.send', 'event', 'Fondo-Home', 'clic', label);
	}
	
	this.submitHidePhoneContact = function(){
		ga('send', 'event', 'Hide-phone', 'Form', 'Send');
		ga('global.send', 'event', 'Hide-phone', 'Form', 'Send');
	}
	
	this.submitEvent = function(agencyId, adId, promotionDetailId, eventType, eventSubtype){
		var label = agencyId+'-'+adId;
		if (promotionDetailId!='') {
			label += "-"+promotionDetailId;
		}
		ga('send', 'event', eventType, eventSubtype, label);
		ga('global.send', 'event', eventType, eventSubtype, label);
	}
	
	this.submitSeePhoneCommerce = function(){		
		this.submitContactCommerce('phone');
	}

	this.submitContactAgencyCommerce = function(){		
		this.submitContactCommerce('contact');
	}
	
	this.submitListingContactAgencyCommerce = function(){		
		this.submitContactCommerce('listing-contact');
	}
	
	this.submitHomeContactAgencyCommerce = function(){		
		this.submitContactCommerce('home-contact');
	}
	
	this.submitDetailContactAgencyCommerce = function(){
		this.submitContactCommerce('detail-contact');
	}
	
	this.submitAggregatorContactAgencyCommerce = function(where){
		this.submitContactCommerce(where + '-contact');
	}
	
	this.submitContactCommerce = function(contactType){
		var transactionId = new Date().getTime();		
		
		ga('require', 'ec');
		ga('global.require', 'ec');
		
		var product={
			'id' : adId, 
			'name' : partner,
			'category' : locationShown,
			'brand':'', 
			'variant': adTitle,
			'price':'0',
			'quantity':1
		};
		ga('ec:addProduct' , product);
		ga('global.ec:addProduct', product);
		
		var purchase={
			'id':adId + '_' + transactionId + '_'+contactType,
			'affiliation':'icasas',
			'revenue':'0',
			'tax':'0',
			'shipping':'0',
			'coupon':'0'
		}
		ga('ec:setAction', 'purchase', purchase);
		ga('global.ec:setAction', 'purchase', purchase);
		ga('send','pageview');
		ga('global.send', 'pageview');
		if (typeof UAPlatform !== 'undefined') {
			ga('platform.send', 'pageview');
		}
	}			
	
	this.submitLandingEvent = function(landing, event, value){
		ga('send', 'event', 'Landing_'+landing, event, value);
		ga('global.send', 'event', 'Landing_'+landing, event, value);
	}
	
	this.setContent = function (contentLevel, value) {
		ga('set', contentLevel, value);
		ga('global.set', contentLevel, value);
//		ga('send','pageview');
//		ga('global.send', 'pageview');

	}	
	
	this.setDimension = function (dimension, value) {
		ga('set', dimension, value);
		ga('global.set', dimension, value);
//		ga('send', 'pageview');
//		ga('global.send', 'pageview');
	}
	
	this.setPlatformDimensions = function () {
		if (typeof UAPlatform !== 'undefined') {
			ga('platform.set', 'dimension1', 'resem');
			ga('platform.set', 'dimension2', UACountryCode);
			ga('platform.set', 'dimension3', 'homes');
		}
	}
	
	this.send = function () {
		if (userId != 0) {
			ga('set', '&uid', userId);
			ga('global.set', '&uid', userId);
		}
		
		if (typeof(error404Page) == "undefined" || !error404Page) {
			ga('send', 'pageview');
			ga('global.send', 'pageview');
			if (typeof UAPlatform !== 'undefined') {
				this.setPlatformDimensions();
				ga('platform.send', 'pageview');
			}
		}
		else {
			ga('send', 'pageview', '/404.html?page=' + document.location.pathname + document.location.search + '&from=' + document.referer);
			ga('global.send', 'pageview', '/404.html?page=' + document.location.pathname + document.location.search + '&from=' + document.referer);
			if (typeof UAPlatform !== 'undefined') {
				this.setPlatformDimensions();
				ga('platform.send', 'pageview');
			}
		}
	}

	this.submitEventAction = function(page, analyticsObjectsActions, label){
		var eventSubtype = analyticsObjectsActions;
		if (typeof page !== "undefined" && page != '') {
			eventSubtype = page + '-' + eventSubtype;
		} else {
			eventSubtype = window.location.pathname + '-' + eventSubtype;
		}
//		console.info('Action event. EventSubtype: ' + eventSubtype + '; label: ' + label);
		ga('send', 'event', 'action', eventSubtype, label);
		ga('global.send', 'event', 'action', eventSubtype, label);
	}

	this.submitEventLogin = function(analyticsObjectsActions, page, elementEvent){
		var label = '';
		if (typeof page !== "undefined" && page != '') {
			label = page;
		} else {
			label = window.location.pathname;
		}
		if (typeof elementEvent !== "undefined" && elementEvent!='') {
			label += '-' + elementEvent;
		}
//		console.info('Login event. analyticsObjectsActions: ' + analyticsObjectsActions + '; label: ' + label);
		ga('send', 'event', 'login', analyticsObjectsActions, label);
		ga('global.send', 'event', 'login', analyticsObjectsActions, label);
	}

	this.submitEventTestAB = function(testName, testOption){
//		console.info('Action event. TestName: ' + testName + '; TestOption: ' + testOption);
        var name = 'test_' + testName;
        var option = name + '_' + testOption;
        ga('send', 'event', 'test', name, option, {'nonInteraction': 1});
		ga('global.send', 'event', 'test', name, option, {'nonInteraction': 1});
	}

	this.track = function(category, event, label) {
        ga('send', 'event', category, event, label);
        ga('global.send', 'event', category, event, label);
    }

}

window.analytics = analytics;
window.analyticsObjects = analyticsObjects;

